export default __webpack_public_path__ + "static/media/banner_confer.98dd5dd4.jpg";